import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
    getPlans,
    getSubscription,
    subscribe,
    cancelSubscription,
    revertScheduledChange,
    PlanCard,
    SubscriptionView,
} from '@/api/billingApi'

const PLANS_KEY = ['billing', 'plans']
const SUBSCRIPTION_KEY = ['billing', 'subscription']

export const useBillingPlans = () =>
    useQuery<PlanCard[]>({ queryKey: PLANS_KEY, queryFn: getPlans })

export const useSubscription = () =>
    useQuery<SubscriptionView>({
        queryKey: SUBSCRIPTION_KEY,
        queryFn: getSubscription,
    })

// Shopify's approval screen cannot render inside the embedded iframe, so the
// redirect has to break out to the top-level window.
export const redirectToApproval = (confirmationUrl: string): void => {
    if (window.top) {
        window.top.location.href = confirmationUrl
        return
    }
    window.location.href = confirmationUrl
}

export const useSubscribe = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: subscribe,
        onSuccess: (result) => {
            queryClient.invalidateQueries({ queryKey: SUBSCRIPTION_KEY })
            redirectToApproval(result.confirmationUrl)
        },
    })
}

export const useCancelSubscription = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: cancelSubscription,
        onSuccess: () =>
            queryClient.invalidateQueries({ queryKey: SUBSCRIPTION_KEY }),
    })
}

export const useRevertScheduledChange = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: revertScheduledChange,
        onSuccess: () =>
            queryClient.invalidateQueries({ queryKey: SUBSCRIPTION_KEY }),
    })
}
